import { render, staticRenderFns } from "./SchoolLeaveDetailEditForm.vue?vue&type=template&id=165e584e&scoped=true&"
import script from "./SchoolLeaveDetailEditForm.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveDetailEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e584e",
  null
  
)

export default component.exports